import { useEffect, useState } from 'react'
import './Skeleton.css'

/**
 * Gösterim (28 Eki 2026, kullanıcı iskeleti görmek istedi): adreste
 * "?iskelet" varsa iskelet 4 saniye görünür, sonra gerçek sayfa. Kopya
 * cihazdayken iskelet hiç çıkmadığı için başka türlü görülemiyor. Veriye
 * dokunmuyor.
 */
export function useSkeletonDemo(): boolean {
  const [on, setOn] = useState(() => new URLSearchParams(window.location.search).has('iskelet'))
  useEffect(() => {
    if (!on) return
    const t = window.setTimeout(() => setOn(false), 4000)
    return () => window.clearTimeout(t)
  }, [on])
  return on
}

/**
 * İskelet ekran (28 Eki 2026, kullanıcı): cihazda henüz kopya yokken (ilk
 * giriş, yeni telefon) bekleme logosu yerine sayfanın kendi şekli görünür,
 * üzerinden bir ışık kayar. Veri gelince gerçek kartlar aynı yere oturur.
 * Kopya varsa hiç görünmez: sayfa kayıtlı haliyle hemen açılır.
 */
export function Skeleton({ kind, label = 'Yükleniyor' }: { kind: 'grid' | 'report' | 'list'; label?: string }) {
  return (
    <div className={`skel skel--${kind}`} role="status" aria-label={label} aria-busy="true">
      {kind === 'grid' && (
        <>
          <div className="skel__bar skel__tabs" />
          {[6, 4].map((n, g) => (
            <section key={g} className="skel__group">
              <div className="skel__bar skel__head" />
              <div className="skel__cards">
                {Array.from({ length: n }, (_, i) => (
                  <div key={i} className="skel__card">
                    <i className="skel__line skel__line--w70" />
                    <i className="skel__line skel__line--w40" />
                  </div>
                ))}
              </div>
            </section>
          ))}
        </>
      )}
      {kind === 'report' && (
        <>
          <div className="skel__tiles">
            {Array.from({ length: 4 }, (_, i) => (
              <div key={i} className="skel__card skel__tile">
                <i className="skel__line skel__line--w40" />
                <i className="skel__line skel__line--big" />
              </div>
            ))}
          </div>
          <div className="skel__card skel__chart" />
        </>
      )}
      {kind === 'list' && (
        <div className="skel__card skel__rows">
          {Array.from({ length: 6 }, (_, i) => (
            <div key={i} className="skel__row">
              <i className="skel__line skel__line--w50" />
              <i className="skel__line skel__line--w20" />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
